"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _jquery = _interopRequireDefault(require("jquery"));

var _core = _interopRequireDefault(require("../../utils/core"));

_core["default"].RichTextEditor.Controls.Underline = _core["default"].RichTextEditor.Control.extend({
  render: function render(editor, $btn) {
    $btn.append("<i class='fas fa-underline'></i>");
  },
  exec: function exec(editor, $btn) {
    editor._execCommand('underline');
  },
  refresh: function refresh(editor, $btn) {
    if (editor._queryCommandState('underline')) {
      $btn.addClass('webf-active');
    } else {
      $btn.removeClass('webf-active');
    }
  },
  types: 'action',
  text_tooltip: 'underline',
  shortcut: {
    Ctrl: true,
    key: 'U'
  }
});